var _defs, _path, _textPath, _circle, _text, _text2, _clipPath, _mask, _text3, _text4, _text5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextLogoAward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 124.72 124.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\n    @font-face { font-family:\"Times New Roman\";font-variant:normal;font-weight:normal;src:url(\"#FontID0\") format(svg)}\n    .str0 {stroke:black;stroke-width:.57}\n    .fil1 {fill:none}\n    .fil0 {fill:black}\n    .fnt2 {font-weight:normal;font-size:11.94px;text-anchor: middle;}\n    .fnt1 {font-weight:normal;font-size:15.94px;text-anchor:middle;}\n\n  "))), /*#__PURE__*/React.createElement("g", {
    id: "rescale_container"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rosette_text",
    "data-type": "curved"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.8,96.4C29.5,89.3 22,76.7 22,62.4 C 22,40.1 40.1,22 62.4,22 C 82.7,22 102.8,40.1 102.8,62.4 c 0,14.5 -7.7,27.3 -19.2,34.4",
    fill: "none",
    stroke: "transparent",
    strokeMiterlimit: 10,
    id: "curve_path",
    "data-width": 80.8
  })), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    style: {
      fontSize: 16,
      fill: "black"
    }
  }, _textPath || (_textPath = /*#__PURE__*/React.createElement("textPath", {
    startOffset: "50%",
    href: "#curve_path"
  }, "\n          YOUR TEXT HERE\n        ")))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "fil1 str0",
    cx: 62.36,
    cy: 62.36,
    r: 58.11,
    id: "plain_border"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo_container"
  }, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 62.36,
    y: 49.81,
    className: "fil0 fnt1"
  }, "LOGO")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 62.36,
    y: 65.91,
    className: "fil0 fnt1"
  }, "HERE")), /*#__PURE__*/React.createElement("rect", {
    className: "logo_position",
    x: 32.34,
    y: 31.93,
    width: 60.94,
    height: 42.52,
    style: {
      fill: "transparent"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "logo_cropped_position",
    x: 23.224,
    y: 20.6528,
    width: 79.25,
    height: 60.52,
    style: {
      fill: "transparent"
    },
    clipPath: "url(#logoCrop)",
    mask: "url(#logoMaskCrop)"
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "logoCrop"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 36.43,
    cx: 62.36,
    cy: 62.36
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "logoMaskCrop"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "77px",
    fill: "white"
  })))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 62.36,
    y: 101.67,
    className: "award_text fil0 fnt2 ",
    fontSize: "31px",
    "data-max_count": 4
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 62.36,
    y: 88.67,
    className: "award_text fil0 fnt2 ",
    "data-line_break": 3.78,
    "data-max_lines": 2,
    "data-max_length": 7.56,
    fontSize: "13.53px"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 62.36,
    y: 88.67,
    className: "award_text_display fil0 fnt2 "
  }, "AWARD HERE"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextLogoAward);
export default __webpack_public_path__ + "static/media/text-logo-award.012910aaa9cbb574768309a8d1fc8ef7.svg";
export { ForwardRef as ReactComponent };